<template>
  <div>
    <div class="hidden pc:block bg-wrapper">
      <div class="flex items-center justify-center bg py-[76px] max-w-[1920px] mx-auto">
        <p class="text-[40px] font-bold text-neutral-950">수강신청 내역확인</p>
      </div>
    </div>

    <section
      v-if="!registrationDetail.registrationDetailList.length > 0"
      class="pt-[55px] pb-[70px] pc:py-[250px] pc-con-wrapper1 flex flex-col items-center gap-7"
    >
      <img src="@/assets/images/myClass/warn.png" alt="icon" class="w-10" />
      <p class="text-xl font-bold text-center pc:text-4xl">수강 신청 내역이 없습니다.</p>
    </section>

    <section v-else class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <p
        class="text-xl font-bold text-center mb-7 pc:text-4xl pc:mb-11"
        v-if="registrationDetail.registrationDetailList.length > 0"
      >
        {{ registrationDetail.registrationDetailList[0].memberName }}
        님의 수강신청 내역입니다.
      </p>
      <!-- 칸이 많아 줄바꿈이 생기지 않도록 한 줄로 두고, 넘치면 가로로 스크롤한다 -->
      <div class="mb-5 overflow-x-auto pc:mb-4">
        <table class="hidden min-w-full whitespace-nowrap border-t border-b border-solid pc:table">
          <thead class="bg-neutral-50">
            <tr class="border-b border-solid border-neutral-200">
              <th class="p-3 text-lg border-r border-solid border-neutral-200">No.</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">수강신청일</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">대상</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">유형</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">레벨</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">수업</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">수업안내</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">교재소개</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">수업시간</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">희망 수업시간</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">수업정보</th>
              <th class="p-3 text-lg border-r border-solid border-neutral-200">결제금액</th>
              <th class="p-3 text-lg" :class="{ 'border-r border-solid border-neutral-200': registrationDetail.showSupColumn() }">수강취소</th>
              <th v-if="registrationDetail.showSupColumn()" class="p-3 text-lg">서류제출</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in registrationDetail.registrationDetailList"
              :key="index"
              class="border-b border-solid border-neutral-200 last-of-type:border-none"
            >
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.rowNum }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.createDate }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">{{ item.sugangSupType || "-" }}</p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.sugangLecType }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.sugangLevel }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.sugangAdult }}
                  {{ item.sugangLang }}
                  {{ item.sugangClassName }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p
                  v-if="item.classInfo && Object.keys(item.classInfo).length > 0"
                  class="font-medium text-orange-500 underline cursor-pointer"
                  @click="registrationDetail.classIntroduction(item.classInfo)"
                >
                  확인
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p
                  v-if="item.bookInfo && Object.keys(item.bookInfo).length > 0"
                  class="font-medium text-orange-500 underline cursor-pointer"
                  @click="registrationDetail.bookIntroduction(item.bookInfo)"
                >
                  확인
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  {{ item.sugangLecType === "1:1" && item.sdate === "배정 전" ? item.sdate : item.stime }}
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">{{ registrationDetail.hopeTimeText(item) }}</p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">
                  주 {{ item.sugangNumberOfClass }}회 {{ item.sugangLessonTime }}분({{ item.lecDayString }})
                </p>
              </td>
              <td class="p-3 border-r border-solid border-neutral-200">
                <p class="font-medium text-neutral-950">{{ item.totalPay }}원</p>
              </td>
              <td class="p-3" :class="{ 'border-r border-solid border-neutral-200': registrationDetail.showSupColumn() }">
                <p v-if="item.cancelStatus === '취소불가'" class="font-medium text-neutral-950">
                  {{ item.cancelStatus }}
                </p>
                <p
                  @click="registrationDetail.getCancle(item)"
                  v-else
                  class="font-medium text-orange-500 underline cursor-pointer"
                >
                  {{ item.cancelStatus }}
                </p>
              </td>
              <td v-if="registrationDetail.showSupColumn()" class="p-3">
                <template v-if="registrationDetail.canSubmitDocument(item)">
                  <div class="flex flex-col items-center gap-1">
                    <a v-if="item.supDocument" :href="item.supDocument" target="_blank" class="font-medium text-blue-500 underline">제출 서류 보기</a>
                    <div v-if="item.isSupDocumentEditable !== 'N'" class="relative group">
                      <!-- 말풍선 -->
                      <p
                        class="absolute bottom-full right-0 z-10 mb-2 hidden w-[200px] whitespace-normal rounded bg-neutral-800 px-3 py-2 text-left text-xs leading-5 text-white group-hover:block"
                      >
                        서류제출 필요 여부는 공지사항을 확인해 주세요.
                      </p>
                      <button
                        type="button"
                        class="font-medium text-orange-500 underline"
                        :class="{ 'pointer-events-none opacity-50': registrationDetail.uploadingIdx }"
                        @click="registrationDetail.pickDocument(item)"
                      >
                        {{ registrationDetail.uploadingIdx === item.idxLeSugangPayInfo ? "업로드 중..." : item.supDocument ? "다시 제출하기" : "서류제출하기" }}
                      </button>
                    </div>
                    <p v-else-if="!item.supDocument" class="text-sm text-neutral-500">제출 기간 종료</p>
                  </div>
                </template>
                <p v-else class="font-medium text-neutral-500">-</p>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- MOBILE -->
        <div class="flex flex-col gap-[70px] pc:hidden">
          <ul
            v-for="(item, index) in registrationDetail.registrationDetailList"
            :key="index"
            class="grid grid-cols-1 border-t border-b border-solid divide-y divide-solid divide-neutral-200"
          >
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">No.</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.rowNum }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수강기간</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.createDate }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">대상</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.sugangSupType || "-" }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">유형</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.sugangLecType }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">레벨</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.sugangLevel }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수업</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">
                {{ item.sugangAdult }}
                {{ item.sugangLang }}
                {{ item.sugangClassName }}
              </p>
            </li>

            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수업안내</p>
              <p
                v-if="item.classInfo && Object.keys(item.classInfo).length > 0"
                class="py-6 text-sm font-medium text-orange-500 underline cursor-pointer pl-11 grow text-neutral-950"
                @click="registrationDetail.classIntroduction(item.classInfo)"
              >
                확인
              </p>
            </li>

            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">교재소개</p>
              <p
                v-if="item.bookInfo && Object.keys(item.bookInfo).length > 0"
                class="py-6 text-sm font-medium text-orange-500 underline cursor-pointer pl-11 grow text-neutral-950"
                @click="registrationDetail.bookIntroduction(item.bookInfo)"
              >
                확인
              </p>
            </li>

            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">교재</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.idxBook1 }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수업시간</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">
                {{ item.sugangLecType === "1:1" && item.sdate === "배정 전" ? item.sdate : item.stime }}
              </p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">희망 수업시간</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ registrationDetail.hopeTimeText(item) }}</p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수업정보</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">
                주 {{ item.sugangNumberOfClass }}회 {{ item.sugangLessonTime }}분({{ item.lecDayString }})
              </p>
            </li>
            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">결제금액</p>
              <p class="py-6 text-sm font-medium pl-11 grow text-neutral-950">{{ item.totalPay }}원</p>
            </li>

            <li class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">수강취소</p>
              <p v-if="item.cancelStatus === '취소불가'" class="py-6 text-sm font-medium pl-11 grow text-neutral-950">
                {{ item.cancelStatus }}
              </p>

              <p
                v-else
                class="py-6 text-sm font-medium text-orange-500 underline cursor-pointer pl-11 grow text-neutral-950"
                @click="registrationDetail.getCancle(item)"
              >
                {{ item.cancelStatus }}
              </p>
            </li>
            <li v-if="registrationDetail.canSubmitDocument(item)" class="flex items-center">
              <p class="text-sm font-bold text-neutral-950 flex-none w-[89px] px-3.5 py-6 bg-neutral-50 text-center">서류제출</p>
              <div class="flex flex-col gap-1 py-4 pl-11 grow">
                <a v-if="item.supDocument" :href="item.supDocument" target="_blank" class="text-sm font-medium text-blue-500 underline">제출 서류 보기</a>
                <template v-if="item.isSupDocumentEditable !== 'N'">
                  <p class="text-xs text-neutral-500">서류제출 필요 여부는 공지사항을 확인해 주세요.</p>
                  <button
                    type="button"
                    class="self-start text-sm font-medium text-orange-500 underline"
                    :class="{ 'pointer-events-none opacity-50': registrationDetail.uploadingIdx }"
                    @click="registrationDetail.pickDocument(item)"
                  >
                    {{ registrationDetail.uploadingIdx === item.idxLeSugangPayInfo ? "업로드 중..." : item.supDocument ? "다시 제출하기" : "서류제출하기" }}
                  </button>
                </template>
                <p v-else-if="!item.supDocument" class="text-sm text-neutral-500">제출 기간 종료</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <p v-if="registrationDetail.isCancleFunction === 'Y'" class="text-sm text-neutral-500 pc:text-lg">
        * 수강취소는
        <span class="text-violet-500">수강신청 마감일 "1일" 전까지</span>
        가능합니다.<br class="pc:hidden" />
        이후 수강취소를 원하시면 당근영어로 문의 부탁드립니다.
      </p>
      <p v-if="registrationDetail.isCancleFunction === 'N'" class="text-sm text-neutral-500 pc:text-lg">
        *수강신청 후
        <span class="text-violet-500">취소는 불가합니다.</span><br class="pc:hidden" />
        수강취소를 원하시면 당근영어로 문의 부탁드립니다.
      </p>
      <!-- 지원서류 제출 안내 (수강신청 화면과 같은 문구) -->
      <ul
        v-if="registrationDetail.showSupColumn()"
        class="mt-4 flex flex-col gap-1 rounded border border-solid border-neutral-200 p-4 text-sm text-neutral-950 pc:text-lg"
      >
        <li>*증빙서류 관련 자세한 사항은 공지사항을 확인해 주세요.</li>
        <li>*서류를 여러 개 제출하시는 경우, 압축하여 하나의 파일로 제출해 주세요.</li>
        <li>*제출 가능한 파일 : zip, pdf, jpg, png / 4MB 이하</li>
      </ul>
      <input ref="documentInput" type="file" accept=".zip,.pdf,.jpg,.jpeg,.png" class="hidden" @change="registrationDetail.onDocumentChange" />
    </section>
  </div>
</template>
<script>
import { reactive, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain; // store 에 저장된 idxLeSiteMain
    const documentInput = ref(null);

    const registrationDetail = reactive({
      registrationDetailList: [], // 수강신청 내역 리스트
      idxLeSugangPayInfo: "", // 수강결제 정보
      isCancleFunction: "", // 수강취소 문구

      idxLeSiteMain: idxLeSiteMain,
      uploadingIdx: 0, // 서류 업로드 중인 신청 idx (중복 클릭 방지)
      pickedItem: null,

      // 지원대상이고 과정이 서류제출을 사용하는 신청만 서류를 낼 수 있다 (값이 없으면 사용으로 본다)
      canSubmitDocument(item) {
        return item && item.sugangSupType === "지원" && item.isSupDocument !== "N";
      },

      showSupColumn() {
        return registrationDetail.registrationDetailList.some((item) => registrationDetail.canSubmitDocument(item));
      },

      pickDocument(item) {
        if (registrationDetail.uploadingIdx) return;
        registrationDetail.pickedItem = item;
        documentInput.value?.click();
      },

      async onDocumentChange(e) {
        const file = e.target.files?.[0];
        const item = registrationDetail.pickedItem;
        e.target.value = "";
        if (!file || !item || registrationDetail.uploadingIdx) return;

        const ext = (file.name.split(".").pop() || "").toLowerCase();
        if (!["zip", "pdf", "jpg", "jpeg", "png"].includes(ext)) return alert("zip, pdf, jpg, png 파일만 제출할 수 있습니다.");
        if (file.size > 4 * 1024 * 1024) return alert("4MB 이하 파일만 제출할 수 있습니다.");

        registrationDetail.uploadingIdx = item.idxLeSugangPayInfo;
        try {
          const formData = new FormData();
          formData.append("file", file);
          const up = await axios.post("/user/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });
          if (!up.data?.success || !up.data?.data?.uploadUrl) return alert(up.data?.message || "파일 업로드에 실패했습니다.");

          const res = await axios.post("/user/sugang/class/supDocument", {
            idxLeSugangPayInfo: item.idxLeSugangPayInfo,
            supDocument: up.data.data.uploadUrl,
          });
          if (!res.data?.success) return alert(res.data?.message || "서류를 제출하지 못했습니다.");

          alert("서류를 제출했습니다.");
          registrationDetail.getRegisterList();
        } catch (err) {
          console.error(err);
          alert("서류 제출 중 오류가 발생했습니다.");
        } finally {
          registrationDetail.uploadingIdx = 0;
          registrationDetail.pickedItem = null;
        }
      },

      // 수업 신청 내역 조회
      getRegisterList() {
        const params = {
          idxLeSiteMain: idxLeSiteMain,
        };
        axios.get(`/user/sugang/class/registerList`, { params }).then(function (res) {
          if (res.data.success === true) {
            registrationDetail.registrationDetailList = res.data.data;
            // registrationDetail.idxLeSugangPayInfo = res.data.data.idxLeSugangPayInfo;
          } else if (res.data.code === 501 || res.data.code === 503) {
            // 로그인이 풀렸거나(501) 쓸 수 없는 토큰(503): 토큰을 비우고 로그인 후 이 화면으로 돌아온다
            store.commit("setAccessToken", "");
            goLogin();
          } else {
            alert(res.data.message);
          }
        });
      },

      // 수강 취소 버튼
      getCancle(item) {
        const idxLeSugangPayInfo = item.idxLeSugangPayInfo;

        axios.post(`/user/sugang/class/cancle?idxLeSugangPayInfo=${idxLeSugangPayInfo}`).then(function (res) {
          if (res.data.success === true) {
            alert("수강이 취소 되었습니다.");
            registrationDetail.getRegisterList();
          } else if (res.data.success === false) {
            alert(res.data.message);
          }
        });
      },

      // 교육 안내 버튼
      classIntroduction(relativePath) {
        if (relativePath) {
          // const absolutePath = `https://${relativePath}`;
          const absolutePath = relativePath;
          window.open(absolutePath, "_blank");
        }
      },

      // 수강신청 때 고른 희망 수업시간 (예: 10:00, 11:00). 없으면 -
      hopeTimeText(item) {
        const times = [item?.sugangHopeTime1, item?.sugangHopeTime2].map((t) => (t || "").trim()).filter(Boolean);
        return times.length ? times.join(", ") : "-";
      },

      // 교재 안내 버튼
      bookIntroduction(relativePath) {
        if (relativePath) {
          // const absolutePath = `https://${relativePath}`;
          const absolutePath = relativePath;
          window.open(absolutePath, "_blank");
        }
      },
    });

    const goLogin = () => {
      router.replace({ path: "/login/login", query: { redirect: route.fullPath } });
    };

    onMounted(() => {
      if (!store.getters.getAccessToken) {
        goLogin();
        return;
      }
      registrationDetail.isCancleFunction = store.state.isCancleFunction;
      registrationDetail.getRegisterList();
    });

    return {
      registrationDetail,
      idxLeSiteMain,
      documentInput,
    };
  },
};
</script>
<style scoped></style>
